import React, { useState } from 'react';
interface ImageGalleryProps {
  images: string[];
  alt: string;
}
export function ImageGallery({
  images,
  alt
}: ImageGalleryProps) {
  const [mainImage, setMainImage] = useState(images[0]);
  const [isZoomed, setIsZoomed] = useState(false);
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isZoomed) return;
    const {
      left,
      top,
      width,
      height
    } = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - left) / width * 100;
    const y = (e.clientY - top) / height * 100;
    setMousePos({
      x,
      y
    });
  };
  return <div className="flex flex-col-reverse md:flex-row gap-4" data-id="element-211">
      {/* Thumbnails */}
      <div className="flex md:flex-col gap-3 overflow-x-auto md:overflow-y-auto md:w-24 pb-2 md:pb-0 hide-scrollbar" data-id="element-212">
        {images.map((img, idx) => <button key={idx} onClick={() => setMainImage(img)} className={`relative flex-shrink-0 w-20 h-24 md:w-full md:h-32 rounded-lg overflow-hidden border-2 transition-all ${mainImage === img ? 'border-sky-500 opacity-100' : 'border-transparent opacity-60 hover:opacity-100'}`} data-id="element-213">
            <img src={img} alt={`${alt} thumbnail ${idx + 1}`} className="w-full h-full object-cover" data-id="element-214" />
          </button>)}
      </div>

      {/* Main Image */}
      <div className="relative flex-1 bg-slate-100 rounded-xl overflow-hidden aspect-[4/5] md:aspect-auto md:h-[600px] cursor-crosshair" onMouseEnter={() => setIsZoomed(true)} onMouseLeave={() => setIsZoomed(false)} onMouseMove={handleMouseMove} data-id="element-215">
        <img src={mainImage} alt={alt} className={`w-full h-full object-cover transition-transform duration-200 ${isZoomed ? 'opacity-0' : 'opacity-100'}`} data-id="element-216" />

        {/* Zoomed version */}
        {isZoomed && <div className="absolute inset-0 bg-no-repeat pointer-events-none" style={{
        backgroundImage: `url(${mainImage})`,
        backgroundPosition: `${mousePos.x}% ${mousePos.y}%`,
        backgroundSize: '200%'
      }} data-id="element-217" />}
      </div>
    </div>;
}